// Function to format a title by splitting it at '{' and inserting a line break
export const formatTitleWithBreak = (title) => {

  // Split the title into two parts using '{' as the separator
  const [firstPart, secondPart] = title.split("{");

  // Remove the closing '}' from the second part if it exists
  const second = secondPart ? secondPart.replace("}", "") : "";

  // Return a JSX fragment with a line break between the two parts
  return (
    <>
      {firstPart.trim()} <br /> {second.trim()}
    </>
  );

};

// Function to clean formatting by removing all curly braces from a string
export const cleanTitleFormatting = (text) => {
  // Use regex to globally remove both '{' and '}' characters
  return text.replace(/[{}]/g, '');
};